import { SettingsParser } from "../../../settings-parser";
import { ColorConverter, ObjectCreator } from "../../../../../../../../web-graphics";
import { SimpleVisualizatorSettings } from "../../../../settings/simple-visualizator-settings";

export class MeanderPlotContentParser extends SettingsParser {
  constructor() {
    super();
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      if (defaultSettings !== undefined) {
        return ObjectCreator.deepCopy(defaultSettings);
      }
      return undefined;
    }
    let parsedSettings = ObjectCreator.merge(settings, defaultSettings);
    if (parsedSettings?.label?.color !== undefined) {
      let parsedColor = ColorConverter.convertToWebglRgba(parsedSettings.label.color);
      parsedSettings.label.color = parsedColor.value;
    }
    if (parsedSettings?.style?.color !== undefined) {
      let parsedColor = ColorConverter.convertToWebglRgba(parsedSettings.style.color);
      parsedSettings.style.color = parsedColor.value;
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = MeanderPlotContentParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    return new SimpleVisualizatorSettings(parsedSettings);
  }
}
